import { createModalContext } from 'modules/campaigns/lib/contexts/createModalContext';

export enum DragAndDropEditorModalType {
  CreateOrEditSavedRow = 'CreateOrEditSavedRow',
  CreativeLibraryPanel = 'CreativeLibraryPanel',
  DynamicContentBuilder = 'DynamicContentBuilder',
  ManageCustomCategories = 'ManageCustomCategories',
  MovableInkPanel = 'MovableInkPanel',
  SavedRowUnsavedChanges = 'SavedRowUnsavedChanges',
  SavedRowUnsavedTemplateChangesWarning = 'SavedRowUnsavedTemplateChangesWarning',
}

/**
 * TODO: make these types stricter
 */
type ModalProps = Record<string, any>;

const PROVIDER_DEBUG_COMPONENT_NAME = 'DragAndDropEditorModalsProvider';

export const {
  ModalContext: DragAndDropEditorModalsContext,
  ModalProvider: DragAndDropEditorModalsProvider,
  useModalContext: useDragAndDropEditorModalsContext,
} = createModalContext<DragAndDropEditorModalType, ModalProps>(PROVIDER_DEBUG_COMPONENT_NAME);
